import { Middleware } from '@reduxjs/toolkit';
import Router from 'next/router';
import { fetchUser } from '../../../utils/redux/authentication/actions';
import { getReturnUrl } from './loginSelectors';

const redirectMiddleware: Middleware =
  ({ getState }) =>
  (next) =>
  (action) => {
    const result = next(action);

    if (action.type === fetchUser.fulfilled.type) {
      const state = getState();
      const returnUrl = getReturnUrl(state);

      Router.replace(returnUrl || '/');
    }

    return result;
  };

export default redirectMiddleware;
